//import gql from "graphql-tag";
import { VueperSlides, VueperSlide } from 'vueperslides';
import 'vueperslides/dist/vueperslides.css';


export default {
  components:{
    VueperSlides, VueperSlide
  },
  methods:{
    getAboutData(){
     fetch('https://vue-middleware-deloitte-commercetools.vercel.app/graphql',{
       method:  'POST',
       headers: {
         'Content-Type': 'application/json',
         'Authorization': `Bearer TNuC0Pa6mP7pjQvXA5HynmcvY-W5WeGD `, // notice the Bearer before your token,
         'origin' :' ',
         'referer' : 'https://vue-middleware-deloitte-commercetools.vercel.app'
         },
       
       body: JSON.stringify({
         query :`{
            getAboutUsContentStackData {
                name
                header {
                  fields {
                    categories {
                      categories {
                        results {
                          name
                          id
                          externalId
                          slug
                          orderHint
                          children {
                            id
                            name
                            externalId
                            slug
                            orderHint
                            children {
                              id
                              externalId
                              name
                              slug
                              orderHint
                            }
                          }
                        }
                      }
                    }
                    isCategoryDataEnabled
                    websiteLogo {
                      sys {
                        id
                        contentType {
                          sys {
                            id
                          }
                        }
                      }
                      fields {
                        url
                        image {
                          fields {
                            title
                            file {
                              fileName
                              url
                              contentType
                            }
                          }
                        }
                      }
                    }
                    topHeader {
                      sys {
                        id
                        contentType {
                          sys {
                            id
                          }
                        }
                      }
                      fields {
                        helpLink {
                          sys {
                            id
                            contentType {
                              sys {
                                id
                              }
                            }
                          }
                          fields {
                            text
                            url
                          }
                        }
                        storeLink {
                          sys {
                            id
                            contentType {
                              sys {
                                id
                              }
                            }
                          }
                          fields {
                            text
                            url
                          }
                        }
                        language {
                          sys {
                            id
                            contentType {
                              sys {
                                id
                              }
                            }
                          }
                          fields {
                            title
                            listItem {
                              fields {
                                text
                              }
                            }
                          }
                        }
                        location {
                          sys {
                            id
                            contentType {
                              sys {
                                id
                              }
                            }
                          }
                          fields {
                            title
                            listItem {
                              fields {
                                text
                                url
                              }
                            }
                          }
                        }
                      }
                    }
                    searchLink {
                      sys {
                        id
                        contentType {
                          sys {
                            id
                          }
                        }
                      }
                      fields {
                        text
                      }
                    }
                    signInLink {
                      sys {
                        id
                        contentType {
                          sys {
                            id
                          }
                        }
                      }
                      fields {
                        iconClass
                        text
                        url
                      }
                    }
                    cartLink {
                      sys {
                        id
                        contentType {
                          sys {
                            id
                          }
                        }
                      }
                      fields {
                        text
                      }
                    }
                    shoppingListLink {
                      sys {
                        id
                        contentType {
                          sys {
                            id
                          }
                        }
                      }
                      fields {
                        text
                        url
                      }
                    }
                  }
                }
                image_with_text_slider {
                  fields {
                    imageText
                    sliderImage {
                      fields {
                        title
                        file {
                          contentType
                          fileName
                          url
                        }
                      }
                    }
                  }
                }
                banner {
                  fields {
                    text
                    image {
                      fields {
                        title
                        file {
                          contentType
                          url
                          fileName
                          contentType
                        }
                      }
                    }
                  }
                }
                paragraph {
                  fields {
                    title
                    text {
                      nodeType
                      content {
                        nodeType
                        content {
                          value
                          nodeType
                          marks {
                            type
                          }
                        }
                      }
                    }
                  }
                }
                banner2 {
                  fields {
                    text
                    image {
                      fields {
                        title
                        file {
                          contentType
                          url
                          fileName
                          contentType
                        }
                      }
                    }
                  }
                }
                footer {
                  sys {
                    id
                    contentType {
                      sys {
                        id
                        linkType
                      }
                    }
                  }
                  fields {
                    text
                    link {
                      sys {
                        contentType {
                          sys {
                            id
                          }
                        }
                      }
                      fields {
                        text
                        url
                      }
                    }
                    logo {
                      sys {
                        contentType {
                          sys {
                            id
                          }
                        }
                      }
                      fields {
                        url
                        image {
                          fields {
                            title
                            file {
                              contentType
                              fileName
                              url
                            }
                          }
                        }
                      }
                    }
                    navLink {
                      sys {
                        contentType {
                          sys {
                            id
                          }
                        }
                      }
                      fields {
                        text
                        url
                      }
                    }
                    title
                    submiText
                    inputPlaceholder
                  }
                }
              }
            }
          `,
       })
     })
       .then(response => response.json())
       .then((data) =>{
       this.imageData= data.data.getAboutUsContentStackData.image_with_text_slider;
       this.content = data.data.getAboutUsContentStackData.paragraph.fields.text.content;
       this.component = data;
       this.text = data.data.getAboutUsContentStackData.paragraph.fields.title;
       this.content.forEach(element => {
        element.content.forEach(ele =>{
          if(ele.nodeType =="text"){
            this.contentVal = ele.value;
          }
        })
       });
      //  this.componentList = Object.keys(data).filter(
      //   (key) => key !== "name"
      // );
       } )
    }
   },

  data() {
    return {
      component: {},
      //componentList: [],
      imageData:[],
      text:'',
      content:[],
      contentVal:'',
      //document,
      //getAboutUsContentStackData: null,
      //isGraphQLREqDone: false,
    };
  },
  mounted() {
    this.getAboutData();
  },
};
